import { render } from "./ClientRequirement.vue?vue&type=template&id=8169dd86&scoped=true"
import script from "./ClientRequirement.vue?vue&type=script&lang=js"
export * from "./ClientRequirement.vue?vue&type=script&lang=js"

import "./ClientRequirement.vue?vue&type=style&index=0&id=8169dd86&scoped=true&lang=scss"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8169dd86"]])

export default __exports__